import React from 'react'
import { OverclaimBulkActionType } from '@App/stores/overclaim/overclaim-search-bulk-action-store'

export interface OverclaimSearchHeaderDescriptionProps {
    bulkActionType: OverclaimBulkActionType | null
}

const OverclaimSearchHeaderDescription = (props: OverclaimSearchHeaderDescriptionProps) => {
    const getDescription = (bulkActionType: OverclaimBulkActionType | null) => {
        switch (bulkActionType) {
            case OverclaimBulkActionType.DocumentUpload:
                return (
                    <>
                        <p>This page allows you to apply the same set of supporting documents to multiple works.</p>
                        <p>
                            Begin by selecting the works you wish to upload documents for, then upload your files and
                            click ‘Submit Documents.
                        </p>
                    </>
                )
            case OverclaimBulkActionType.AmendmentSelection:
            case OverclaimBulkActionType.AmendmentEdit:
                return (
                    <>
                        <p>
                            Update your share percentages across multiple works at once. To get started, select the
                            works you wish to modify. Only share amounts can be adjusted; publisher and administrator
                            details will remain unchanged. A summary of your updates will be displayed before you
                            submit.
                        </p>
                    </>
                )
            case null:
                return (
                    <>
                        <p>
                            The Overclaims Tool enables Members to see works they have registered that are in overclaim.
                            Overclaims occur when the total shares submitted by Members for a work add up to more than
                            100%. Members can also use the Overclaims Tool to send an email to all Members claiming
                            shares of a work so that all claimants can work together to resolve the overclaim.
                        </p>
                        <p>
                            Click{' '}
                            <a
                                target="_blank"
                                href="https://help.themlc.com/en/support/what-is-an-overclaim-and-how-do-i-resolve-one-using-the-overclaims-tool"
                                rel="noreferrer"
                            >
                                here{' '}
                            </a>
                            for our Help Center article detailing options to resolve an overclaim.
                        </p>
                    </>
                )
            default:
                return ''
        }
    }

    return <>{getDescription(props.bulkActionType)}</>
}

export default OverclaimSearchHeaderDescription
